import { taggedTemplate } from '@angular/compiler/src/output/output_ast';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { ContainerComponent } from './container/container.component';
import { LoginComponent } from './login/login.component';

import { NewEntryScannerComponent } from './new-entry-scanner/new-entry-scanner.component';
import { SelectFeatureComponent } from './select-feature/select-feature.component';
import { StopWatchComponent } from './stop-watch/stop-watch.component';

const routes: Routes = [
  {
    path:'',
    component:LoginComponent,
    
   
  },
  // {
   // path:'login',
   // component:LoginComponent
 // },
{
  path:'workCompleted',
  component:ContainerComponent,
  canActivate:[AuthGuard]
},
{
  path:'selectFeature',
  component:SelectFeatureComponent,
  
},

{
  path:'NewEntry',
  component:NewEntryScannerComponent
},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
  export class AppRoutingModule {}

export const routingComponents=[ContainerComponent,NewEntryScannerComponent,SelectFeatureComponent]


